import React from 'react';
import { Divider, Grid, Skeleton, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styles } from './styles';
import AuditLog from '../../../components/common/AuditLog';
import { UserMenu } from '../Users/UserMenu';
import ActionButton from '../../../components/common/ActionButtonAndMenu/ActionButton';
import AuditLogTable from '../../../components/common/AuditLog/AuditLogTable';

const UserDataDisplay = ({ title, value }) => (
    <Grid
        item
        xs={4}
        sx={{
            pt: '32px !important',
        }}
    >
        <Typography color="neutral.600" variant="body2">
            {title}
        </Typography>
        {typeof value === 'string' || !value ? (
            <Typography
                color="neutral.700"
                variant="h6"
                sx={{
                    pt: 2,
                }}
            >
                {value}
            </Typography>
        ) : (
            value
        )}
    </Grid>
);

const UserData = ({ user, isLoading, id }) => {
    const navigate = useNavigate();

    if (isLoading) {
        return (
            <Box sx={{ p: 2 }}>
                <Skeleton height={42} />
                <Skeleton height={42} />
                <Skeleton height={42} />
            </Box>
        );
    }

    const details = {
        'User Name/Email ID': user?.secUserInstance?.username,
        'First Name': user?.employeeInstance?.firstName,
        'Last Name': user?.employeeInstance?.lastName,
        'Contact Number': user?.employeeInstance?.mobileNumbers?.[0],
    };

    const accountDetails = {
        'Password Expired': user?.secUserInstance?.passwordExpired ? 'Yes' : 'No',
        'Account Locked': user?.secUserInstance?.accountLocked ? 'Yes' : 'No',
        'Account Enabled': user?.secUserInstance?.enabled ? 'Yes' : 'No',
    };

    return (
        <Grid container spacing={4}>
            <Grid item md={12} xs={12}>
                <Grid
                    container
                    spacing={3}
                    sx={{
                        mb: 5,
                    }}
                >
                    <Grid item xs={12}>
                        <Box sx={styles.titleWrapper} alignItems={'center'}>
                            <Typography color="neutral.600" variant="subtitle2">
                                User Details
                            </Typography>
                            <UserMenu
                                Component={ActionButton}
                                row={{
                                    id: user?.secUserInstance?.employeeId,
                                    userID: id,
                                    userName: user?.secUserInstance?.username,
                                    roleList: details['Role']?.split(','),
                                    ...user,
                                }}
                                keyColumn="userID"
                                handleAction={() => navigate('/users')}
                            />
                        </Box>
                    </Grid>
                    {Object.keys(details).map((key) => (
                        <UserDataDisplay key={key} title={key} value={details[key]} />
                    ))}
                    <Grid item xs={12}>
                        <Box sx={styles.titleWrapper}>
                            <Typography color="neutral.600" variant="subtitle2">
                                Account Details
                            </Typography>
                        </Box>
                    </Grid>
                    {Object.keys(accountDetails).map((key) => (
                        <UserDataDisplay key={key} title={key} value={accountDetails[key]} />
                    ))}
                    <Grid item xs={12}>
                        <Box sx={styles.titleWrapper}>
                            <Typography color="neutral.600" variant="subtitle2">
                                Role Details
                            </Typography>
                        </Box>
                    </Grid>
                    {Object.keys(user?.companyRoles || {}).map((key) => (
                        <React.Fragment key={key}>
                            <UserDataDisplay title={'Company'} value={key} />
                            <UserDataDisplay title={'Role'} value={user?.companyRoles[key]} />
                            <Grid item xs={4} />
                        </React.Fragment>
                    ))}
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12}>
                <AuditLog
                    data={[
                        {
                            title: 'Audit Logs',
                            logs: user.commentsMap || [],
                            Component: AuditLogTable,
                        },
                    ]}
                />
            </Grid>
        </Grid>
    );
};

export default UserData;
